module.exports = "//static.hsappstatic.net/pricing-pages-ui/static-1.18759/js/img/productIcons/ServiceHub_Starter.svg"